import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';

import { Sheet } from '@/components/common/Sheet';
import { useDeleteMyDmMessagesMutation } from '@/services/dmApi';

/**
 * D4 — «Cancella i miei messaggi», con conferma (L-2231 (a), 15:16:08Z: «Da solo, nell'app: un comando
 * «Cancella i miei messaggi», con conferma»). La rotta cancella tutto cio' che l'utente ha scritto, in
 * tutte le conversazioni, anche dalla vista dell'altro (P1, §1-ter): il testo del foglio lo dice.
 * La DELETE parte SOLO dal bottone del foglio.
 */
export function CancellaMieiMessaggi() {
  const { t } = useTranslation('general');
  const [aperto, setAperto] = useState(false);
  const [esito, setEsito] = useState<string | null>(null);
  const [cancella, { isLoading }] = useDeleteMyDmMessagesMutation();

  const conferma = async () => {
    try {
      const r = await cancella().unwrap();
      setEsito(t('social.dm.cancella.fatto', { deleted: r.deleted, conversations: r.conversations }));
      setAperto(false);
    } catch {
      setEsito(t('social.dm.cancella.errore'));
    }
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <button
        type="button"
        onClick={() => {
          setEsito(null);
          setAperto(true);
        }}
        className="flex items-center gap-1 text-xs text-fg-muted underline"
      >
        <Trash2 aria-hidden className="h-3.5 w-3.5" />
        {t('social.dm.cancella.link')}
      </button>
      {esito ? (
        <p role="status" className="text-xs text-fg-muted">
          {esito}
        </p>
      ) : null}
      <Sheet open={aperto} onClose={() => setAperto(false)} label={t('social.dm.cancella.titolo')}>
        <div className="flex flex-col gap-3 px-5 pb-6 pt-2">
          <p className="text-lg font-extrabold text-fg">{t('social.dm.cancella.titolo')}</p>
          <p className="text-sm text-fg">{t('social.dm.cancella.testo')}</p>
          <p className="text-sm text-fg-muted">{t('social.dm.cancella.irreversibile')}</p>
          <button
            type="button"
            data-testid="dm-cancella-conferma"
            disabled={isLoading}
            onClick={() => void conferma()}
            className="mt-2 h-12 rounded-2xl bg-danger font-extrabold text-white disabled:opacity-50"
          >
            {t('social.dm.cancella.conferma')}
          </button>
          <button
            type="button"
            onClick={() => setAperto(false)}
            className="h-12 rounded-2xl bg-bg-secondary font-bold text-fg"
          >
            {t('social.dm.cancella.annulla')}
          </button>
        </div>
      </Sheet>
    </div>
  );
}
